import { WarningAlt } from '@carbon/icons-react';
import { Content, Section, Heading, Tile, Grid, Column } from '@carbon/react';
import { useLocation, Link, useRouteLoaderData } from 'react-router';
import { CarbonHeader } from './carbon-header.tsx';
import { type loader as rootLoader } from '../root.tsx';

export function NotFound() {
	const location = useLocation();
	const rootData = useRouteLoaderData<typeof rootLoader>('root');
	const userPreference = rootData?.requestInfo?.userPrefs?.theme;

	return (
		<>
			<CarbonHeader userPreference={userPreference} />
			<Content className="mt-0! min-h-screen bg-gray-50 dark:bg-gray-900">
				<Grid>
					<Column sm={4} md={8} lg={16}>
						<Section className="flex justify-center mt-52">
							<div className="mx-auto w-full max-w-md">
								<Tile className="p-8!">
									<div className="flex flex-col items-center space-y-6">
										<div className="p-4 bg-yellow-100 dark:bg-yellow-900/20 rounded-full">
											<WarningAlt
												size={48}
												className="text-yellow-600 dark:text-yellow-400"
											/>
										</div>

										<div className="space-y-2 text-center">
											<Heading className="text-xl font-semibold text-gray-900 dark:text-white">
												Page Not Found
											</Heading>
											<p className="text-gray-600 dark:text-gray-400 max-w-sm">
												Oops! It looks like the page you're searching for isn't
												here or has been moved.
											</p>
										</div>

										<div className="text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-neutral-blue-810 p-4 rounded w-full">
											<p className="mb-2 font-semibold">Requested URL:</p>
											<pre className="whitespace-pre-wrap break-all text-xs font-mono bg-gray-200 dark:bg-neutral-blue-900 p-2 rounded text-gray-800 dark:text-gray-200">
												{location.pathname}
											</pre>
										</div>

										<div className="pt-4">
											<Link
												to="/"
												className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline"
											>
												← Back to Home
											</Link>
										</div>
									</div>
								</Tile>
							</div>
						</Section>
					</Column>
				</Grid>
			</Content>
		</>
	);
}
